// ═══════════════════════════════════════════════════════════════
// SHARED STYLES UTILITY
// ═══════════════════════════════════════════════════════════════
export const S = {
  app: {
    minHeight: "100vh",
    background: "#06070f",
    color: "#e2e8f0",
    fontFamily: "'IBM Plex Mono','Courier New',monospace",
  },
  nav: {
    background: "#0a0b14",
    borderBottom: "1px solid #151728",
    padding: "10px 18px",
    display: "flex",
    alignItems: "center",
    gap: 8,
    position: "sticky",
    top: 0,
    zIndex: 50,
  },
  card: (active, c) => ({
    background: active ? `${c}15` : "#0d0e1a",
    border: `1px solid ${active ? c + "55" : "#151728"}`,
    borderRadius: 12,
    cursor: "pointer",
    transition: "all 0.15s",
  }),
  btn: (c, outline) => ({
    background: outline ? "transparent" : c,
    border: `1px solid ${c}`,
    borderRadius: 8,
    color: outline ? c : "#000",
    cursor: "pointer",
    fontFamily: "inherit",
    fontWeight: 700,
    transition: "all 0.15s",
  }),
  tag: (c) => ({
    background: `${c}18`,
    border: `1px solid ${c}33`,
    borderRadius: 99,
    padding: "3px 10px",
    fontSize: 11,
    color: c,
    fontWeight: 600,
  }),
};
